import React from "react";
import Navbar from "../components/sections/Navbar";
import Hero from "../components/sections/Hero";
import PricingCalculator from "../components/sections/PricingCalculator";
import Features from "../components/sections/Features";
import TrustBand from "../components/sections/TrustBand";
import DedicatedTeaser from "../components/sections/DedicatedTeaser";
import FinalCTA from "../components/sections/FinalCTA";
import Container from "../components/ui/Container";
import Button from "../components/ui/Button";
import { BRAND } from "../lib/config";

export default function HomePage() {
  return (
    <div className="min-h-screen bg-slate-950 text-white">
      <main>
        <Hero />
        <PricingCalculator />
        <Features />
        <TrustBand />
        { /* <DedicatedTeaser /> */}
        <FinalCTA />
      </main>
    </div>
  );
}